import React from 'react';
import { Container, Row } from 'react-bootstrap';

import PageHeader from "./components/PageHeader";
import ActionHeader from "./components/ActionHeader";
import DataTable from "./components/DataTable";
import DeleteData from "./components/DeleteData";
import TableSelector from "./components/TableSelector";
import useDatabaseTables from "./components/useDatabaseTables";

function DeletePage() {
  const API_URL = process.env.REACT_APP_API_URL;

  const {
    resultsTable,
    selectedTable,
    setSelectedTable,
    results,
    fetchTableData,
    resetResults
  } = useDatabaseTables(API_URL);

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchTableData(selectedTable);
  };

  return (
    <Container className="mt-5">

      <PageHeader title="Eliminazione riga" />

      {/* Selezione tabella */}
      <TableSelector
        resultsTable={resultsTable}
        selectedTable={selectedTable}
        setSelectedTable={(val) => { setSelectedTable(val); resetResults(); }}
        onSubmit={handleSubmit}
      />

      {/* Tabella dati */}
      {results && results.columns && (
        <Row className='mt-5'>
          <DataTable columns={results.columns} rows={results.rows} />
        </Row>
      )}

      {/* Eliminazione riga */}
      {results && results.rows && (
        <Row className='mt-5 mb-5'>
          <ActionHeader actionTitle="🗑️ Elimina riga" />
          <DeleteData 
            data={results.rows} 
            tableName={selectedTable} 
            onDelete={() => fetchTableData(selectedTable)} 
          />
        </Row>
      )}

    </Container>
  );
}

export default DeletePage;
